<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog">
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon">
                        <div class="h-formBox" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                                <el-form-item label="用户类型">
                                    <el-select v-model="q.usertype" clearable>
                                        <el-option label="经销商" value="1"></el-option>
                                        <el-option label="用户" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="用户账号/姓名">
                                    <el-input clearable v-model="q.usercodename"></el-input>
                                </el-form-item>
                                <el-form-item class="h-formBtnOut">
                                    <el-button type="primary"  icon="el-icon-search" @click="handleFilter">搜索</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
								:border="true"
                                :data="ttdata"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="user_code"
                                    label="用户类型"
                                    width="100"
									:show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{scope.row.userType|yonghulx}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="userCode"
                                    label="账号"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="userName"
                                    label="名称"
                                    width="200"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="department"
                                    width="110"
                                    label="部门"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="contactUserName"
                                    width="110"
                                    label="联系人"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="telephone"
                                    label="电话"
                                    width="150"
									:show-overflow-tooltip="true">
                            </el-table-column>
                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="queryUser"/>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        filters:{
          yonghulx:function(v){
              return v==1?"经销商":"用户"
          }
        },
        data(){
          return {
              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,
                  usertype:null,
                  usercodename:null,
              },
              ttdata:null,
              users:[]
          }
        },
        created(){
          this.q.usertype = this.usertype
        },
        methods: {
            handleFilter(){
                this.queryUser();
            },
            queryUser(){
                ss.UserDemand.custagentPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;
                })
            },
            handleSelectionChange(users){
                if(this.oneflag){
                    this.$emit('choseObj', users[0])
                }else{
                    this.$emit('choseObj', users)
                }
            },
        },
        created(){
            this.queryUser()
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            usertype:{
                type:Number,
            },
            oneflag:{
                type:Boolean,
                default:true,
            }
        }
    }
</script>

<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
</style>
